import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { nonProdOnlyGuard } from './non-prod-only.guard';
import { pendingLessonChangesGuard } from './guided-lesson/pending-lesson-changes.guard';

export const routes: Routes = [
  {
    path: 'dashboard',
    pathMatch: 'full',
    loadComponent: () =>
      import('./sales-growth/sales-growth.component').then(
        (module) => module.SalesGrowthComponent
      ),
    canActivate: [AuthGuard],
    data: { roles: ['ADMIN', 'MARKETING'] },
  },
  {
    path: 'dashboard/exam-readiness',
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(
        (module) => module.DashboardComponent
      ),
    canActivate: [AuthGuard],
    data: { roles: ['ADMIN', 'MARKETING'] },
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    data: { roles: ['ADMIN', 'EDITOR', 'MARKETING'] },
    loadComponent: () =>
      import('./home/home.component').then((module) => module.HomeComponent),
    children: [
      {
        path: 'phone-verification',
        canActivate: [AuthGuard],
        data: { roles: ['ADMIN'] },
        loadComponent: () => import('./account-safety/account-safety.component').then(m => m.AccountSafetyComponent),
      },
      {
        path: '',
        redirectTo: 'category',
        pathMatch: 'full',
      },
      {
        path: 'category',
        loadComponent: () =>
          import('./category-list/category-list.component').then(
            (module) => module.CategoryListComponent
          ),
      },
      {
        path: 'chapters/:id',
        loadComponent: () =>
          import('./questions/Questions-Group/questionsGroup.component').then(
            (module) => module.QuestionsGroupComponent
          ),
      },
      {
        path: 'callHistory/:id',
        loadComponent: () =>
          import('./call-history/call-history.component').then(
            (module) => module.CallHistoryComponent
          ),
      },
      {
        path: 'questions-edit/:id',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import(
            './questions/questions/questions-edit/questions-edit.component'
          ).then((module) => module.QuestionEditComponent),
      },
      {
        path: 'questionGroup-edit/:id',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import(
            './questions/Questions-Group/question-group-edit/question-group-edit.component'
          ).then((module) => module.QuestionGroupEditComponent),
      },
      {
        path: 'question-sets/:id',
        loadComponent: () =>
          import('./questions/question-set/question-set.component').then(
            (module) => module.QuestionSetComponent
          ),
      },
      {
        path: 'sub-Chapter/:id',
        loadComponent: () =>
          import('./sub-chapter/sub-chapter.component').then(
            (module) => module.SubChapterComponent
          ),
      },
      {
        path: 'units/:id',
        loadComponent: () =>
          import('./unit-list/unit-list.component').then(
            (module) => module.UnitListComponent
          ),
      },
      {
        path: 'questionSet-edit/:id',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import(
            './questions/question-set/question-set-edit/question-set-edit.component'
          ).then((module) => module.QuestionSetEditComponent),
      },
      {
        path: 'notification-edit/:id',
        loadComponent: () =>
          import('./notification-edit/notification-edit.component').then(
            (module) => module.NotificationEditComponent
          ),
      },
      {
        path: 'sub-chapter-edit/:id',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import(
            './sub-chapter/sub-chapter-edit/sub-chapter-edit.component'
          ).then((module) => module.SubChapterEditComponent),
      },
      {
        path: 'question-set-questions/:id',
        loadComponent: () =>
          import(
            './question-set-questions/question-set-questions.component'
          ).then((module) => module.QuestionSetQuestionsComponent),
      },
      {
        path: 'questionsSets-add',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import(
            './questions/question-set/question-set-add/question-set-add.component'
          ).then((module) => module.QuestionSetAddComponent),
      },
      {
        path: 'questions-add',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import(
            './questions/questions/questions-add/questions-add.component'
          ).then((module) => module.QuestionAddComponent),
      },
      {
        path: 'questions/:id',
        loadComponent: () =>
          import('./questions/questions/questions.component').then(
            (module) => module.QuestionsComponent
          ),
      },
      {
        path: 'options',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./options/options.component').then(
            (module) => module.OptionsComponent
          ),
      },
      {
        path: 'excelupload',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./excelfileupload/excelfileupload.component').then(
            (module) => module.ExcelfileuploadComponent
          ),
      },
      {
        path: 'callHistory-add/:id',
        loadComponent: () =>
          import('./call-historyadd/call-historyadd.component').then(
            (module) => module.CallHistoryaddComponent
          ),
      },
      {
        path: 'userActivity',
        loadComponent: () =>
          import('./user-activity/user-activity.component').then(
            (module) => module.UserActivityComponent
          ),
      },
      {
        path: 'convertchapter',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./convertchapter/convertchapter.component').then(
            (module) => module.ConvertchapterComponent
          ),
      },
      {
        path: 'option-add',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./options/option-add/option-add.component').then(
            (module) => module.OptionsAddComponent
          ),
      },
      {
        path: 'option-edit/:id',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./options/option-edit/option-edit.component').then(
            (module) => module.OptionsEditComponent
          ),
      },
      {
        path: 'report',
        loadComponent: () =>
          import('./report/report.component').then(
            (module) => module.ReportComponent
          ),
      },
      {
        path: 'staff-activity-report',
        loadComponent: () =>
          import(
            './staff-activity-report/staff-activity-report.component'
          ).then((module) => module.StaffActivityReportComponent),
        canActivate: [AuthGuard],
        data: { roles: ['ADMIN', 'MARKETING'] },
      },
      {
        path: 'notification',
        loadComponent: () =>
          import('./notification/notification.component').then(
            (module) => module.NotificationComponent
          ),
      },
      {
        path: 'notification-edit',
        loadComponent: () =>
          import('./notification-edit/notification-edit.component').then(
            (module) => module.NotificationEditComponent
          ),
      },
      {
        path: 'create-coin',
        loadComponent: () =>
          import('./create-coin/create-coin.component').then(
            (module) => module.CreateCoinComponent
          ),
      },
      {
        path: 'forum/:id',
        loadComponent: () =>
          import('./discussion-forum/discussion-forum.component').then(
            (module) => module.DiscussionForumComponent
          ),
      },
      {
        path: 'forum-inbox',
        loadComponent: () =>
          import('./forum-inbox/forum-inbox.component').then(
            (module) => module.ForumInboxComponent
          ),
      },
      {
        path: 'institutions',
        loadComponent: () =>
          import('./institution-catalog/institution-catalog.component').then(
            (module) => module.InstitutionCatalogComponent
          ),
        canActivate: [AuthGuard],
        data: { roles: ['ADMIN'] },
      },
      {
        path: 'institution-submissions',
        loadComponent: () =>
          import(
            './institution-submissions/institution-submissions.component'
          ).then((module) => module.InstitutionSubmissionsComponent),
        canActivate: [AuthGuard],
        data: { roles: ['ADMIN'] },
      },
      {
        path: 'coin-history',
        loadComponent: () =>
          import('./coin-transactions/coin-transactions.component').then(
            (module) => module.CoinTransactionsComponent
          ),
      },
      {
        path: 'vector-store',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./vector-store/vector-store.component').then(
            (module) => module.VectorStoreComponent
          ),
      },
      {
        path: 'subscription',
        loadComponent: () =>
          import('./subscription-list/subscription-list.component').then(
            (module) => module.SubscriptionListComponent
          ),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./user-list/user-list.component').then(
            (module) => module.UserListComponent
          ),
      },
      {
        path: 'gift-codes',
        loadComponent: () =>
          import('./gift-code-list/gift-code-list.component').then(
            (module) => module.GiftCodeListComponent
          ),
      },
      {
        path: 'units/:unitId/notes',
        loadComponent: () =>
          import('./notes/notes-list/notes-list.component').then(
            (module) => module.NotesListComponent
          ),
      },
      {
        path: 'units/:unitId/notes/add',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./notes/notes-add/notes-add.component').then(
            (module) => module.NotesAddComponent
          ),
      },
      {
        path: 'units/:unitId/notes/:noteId/edit',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./notes/notes-edit/notes-edit.component').then(
            (module) => module.NotesEditComponent
          ),
      },
      {
        path: 'units/:unitId/notes/:noteTopicId/subtopics',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./notes/subtopics/subtopics.component').then(
            (module) => module.SubtopicsComponent
          ),
      },
      {
        path: 'units/:unitId/notes/:noteTopicId/guided-lesson/:subtopicId',
        canActivate: [nonProdOnlyGuard],
        canDeactivate: [pendingLessonChangesGuard],
        loadComponent: () =>
          import('./guided-lesson/guided-lesson-editor.component').then(
            (module) => module.GuidedLessonEditorComponent
          ),
      },
      {
        path: 'chat',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./mcp-chat/mcp-chat.component').then(
            (module) => module.McpChatComponent
          ),
      },
      {
        path: 'cdc-events',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./change-event/change-event.component').then(
            (module) => module.ChangeEventComponent
          ),
      },
      {
        path: 'transaction-records',
        canActivate: [nonProdOnlyGuard],
        loadComponent: () =>
          import('./transaction-records/transaction-records.component').then(
            (module) => module.TransactionRecordsComponent
          ),
      },
      {
        path: 'desktop-releases',
        loadComponent: () =>
          import('./desktop-release/desktop-release.component').then(
            (module) => module.DesktopReleaseComponent
          ),
      },
      {
        path: 'mobile-updates',
        loadComponent: () =>
          import(
            './mobile-update-control/mobile-update-control.component'
          ).then((module) => module.MobileUpdateControlComponent),
        canActivate: [AuthGuard],
        data: { roles: ['ADMIN'] },
      },
    ],
  },
  {
    path: '',
    redirectTo: '/home/category',
    pathMatch: 'full',
  },
];
